<template>
  <div>
    <div class="blank"></div>
    <v-toolbar color="#0a3444" class="top-toolbar">
      <v-toolbar-items>
        <v-btn fab small @click="$emit('display', false)" class="top-toolbar-button">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>

      <div class="btn-group">
        <v-btn-toggle v-model="sort" mandatory>
          <v-btn flat value="caseasc">
            <span>Cases</span>
            <v-icon>arrow_upward</v-icon>
          </v-btn>
          <v-btn flat value="casedesc">
            <span>Cases</span>
            <v-icon>arrow_downward</v-icon>
          </v-btn>
          <v-btn flat value="vehicleasc">
            <span>Vehicles</span>
            <v-icon>arrow_upward</v-icon>
          </v-btn>
          <v-btn flat value="vehicledesc">
            <span>Vehicles</span>
            <v-icon>arrow_downward</v-icon>
          </v-btn>
          <v-btn flat value="timeasc">
            <span>Time</span>
            <v-icon>arrow_upward</v-icon>
          </v-btn>
          <v-btn flat value="timedesc">
            <span>Time</span>
            <v-icon>arrow_downward</v-icon>
          </v-btn>
          <v-btn flat value="kmasc">
            <span>Km</span>
            <v-icon>arrow_upward</v-icon>
          </v-btn>
          <v-btn flat value="kmdesc">
            <span>Km</span>
            <v-icon>arrow_downward</v-icon>
          </v-btn>
        </v-btn-toggle>
      </div>

      <v-toolbar-items>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              solo
              class="toolbar-item"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
        </v-menu>
        <v-combobox 
          solo 
          class="toolbar-item" 
          item-text="Name" 
          item-value="Id" 
          v-model="selectedGroup" 
          :items="group" 
          label="Group" 
          @change="handleChangeGroup"></v-combobox>
      </v-toolbar-items>
    </v-toolbar>
    <div class="gantt">
      <div class="gantt__row gantt__row--months">
        <div class="gantt__row-first"></div>
        <span v-for="i in 24" :key="i" v-show="i >= 8 && i<= 20">{{i}}:00</span>
      </div>
      <div class="gantt__row gantt__row--lines" data-month="5">
        <span v-for="i in 24" :key="i" v-show="i >= 8 && i<= 20" :class="displayCurrentTime(i)"></span>
      </div>
      <div
        class="gantt__row"
        v-for="(supporter, index) in datasourceFiltered"
        :key="index"
        v-show="supporter.Cases.filter(a => a.Type === 'New' && !a.Hide).length > 0"
      >
        <div class="gantt__row-first">
          <p class="sup-name">G{{supporter.Group}} - {{supporter.Name}}</p>
          <p class="para">Cases: {{ countCaseBySupporter(supporter) }}</p>
          <p
            class="para"
          >Vehicles: {{ countVehicleBySupporter(supporter)[1] }} New / {{ countVehicleBySupporter(supporter)[2] }} SC</p>
          <p v-if="supporter.MorningOffline === 'True'" class="pl-2 text-xs-left red--text">Nghỉ buổi sáng</p>
          <p v-if="supporter.AfternoonOffline === 'True'" class="pl-2 text-xs-left red--text">Nghỉ buổi chiều</p>
        </div>
        <ul class="gantt__row-bars">
          <li
            v-for="(task, index2) in supporter.Cases.filter(a => moment(a.Plan).add(7, 'hours').date() === moment(date).date())"
            :key="index2"
            :style="getTaskDuration(task)"
            :class="`${getTaskColor(task)} stripes`"
            v-show="!task.Hide"
          >
            <template>
              <div class="text-xs-center">
                <v-menu :close-on-content-click="false" :nudge-width="200" offset-x>
                  <template v-slot:activator="{ on }">
                    <div v-show="task.Type === 'Rest'">
                      <v-icon class="task-rest">restaurant</v-icon>
                      <v-icon class="task-rest">airline_seat_individual_suite</v-icon>
                    </div>

                    <label
                      v-show="task.Type !== 'Rest'"
                      v-on="on"
                      class="case-number-label"
                    >#{{task.CaseNumber}}</label>

                    <label v-show="task.Type !== 'Rest'" v-on="on" class="case-driving">
                      <br />
                      {{moment(task.Plan).add(7 , 'hours').format('HH:mm')}} -
                      {{moment(task.Plan).add(7, 'hours').add(task.InstallationDuration, 'minutes') .format('HH:mm')}}
                    </label>

                    <label v-on="on" class="case-driving" v-show="task.Type !== 'Rest'">
                      <br />
                      {{`${task.ErrorType === 'New' ? 'New' : 'SC'}`}}
                      {{task.InstallationQuantity}}
                      <v-icon
                        class="vehicle-icon"
                        dark
                        v-show="task.InstallationQuantity > 0"
                      >directions_car</v-icon>
                    </label>

                    <label
                      v-show="task.Type === 'New'"
                      v-if="task.Type === 'New'"
                      v-on="on"
                      class="case-driving"
                    >
                      <br />
                      {{task.Before.Time.toFixed(0) }}p / {{task.Before.Distance.toFixed(0)}}km
                      <br />
                      {{task.After.Time.toFixed(0) }}p / {{task.After.Distance.toFixed(0)}}km
                    </label>
                  </template>
                  <v-card>
                    <v-card-text>
                      <h5>
                        <a :href="getCrmCaseUrl(task)" target="_blank">#{{task.CaseNumber}}</a>
                      </h5>
                      <p class="task-detail">{{task.Vehicle}}</p>
                      <p class="task-detail">Repair Location: {{task.RepairLocation}}</p>
                      <p class="task-detail">Location: {{task.Location}}</p>

                      <p
                        class="task-detail"
                      >Plan: {{ getTimeFromPlan(task.Plan).format("YYYY-MM-DD, HH:mm:ss")}}</p>

                      <p class="task-detail">Duration: {{task.InstallationDuration}} min</p>
                      <p class="task-detail">Repair person: {{task.RepairPerson}}</p>
                      <p class="task-detail">Repair person list: {{task.RepairPersonList}}</p>
                      <p class="task-detail">ErrorType: {{task.ErrorType}}</p>
                      <p
                        class="task-detail"
                        v-show="task.Finished"
                      >Finished: {{ getTimeFromPlan(task.Finished).format('YYYY-MM-DD, HH:mm:ss')}}</p>
                      <p
                        class="task-detail"
                        v-if="task.Type==='New'"
                      >Case Before: {{task.Before.Time.toFixed(2) }} min / {{task.Before.Distance.toFixed(2)}} km</p>
                      <p
                        class="task-detail"
                        v-if="task.Type==='New'"
                      >Case After: {{task.After.Time.toFixed(2)}} min / {{task.After.Distance.toFixed(2)}} km</p>
                      <v-btn
                        block
                        color="green"
                        v-if="task.Type==='New'"
                        dark
                        :loading="isDispatching"
                        @click="dispatch(task, supporter.GoogleChatWebhook)"
                      >Điều phối</v-btn>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </div>
    <div class="help-button">
      <help />
    </div>
  </div>
</template>

<script>
import moment, { lang } from 'moment';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import * as MapUtil from '@/utils/maputil';
import Help from '@/components/DispatchHelp.vue';
import { convertGMTToLocalTime } from '@/utils/datetime';

export default {
  components: {
    Help
  },
  props: {
    selectedCase: Object,
    supporters: Array
  },
  data () {
    return {
      datasource: [],
      datasourceFiltered: [],
      moment: moment,
      menu: false,
      date: moment()
        .add(-1, 'days')
        .format('YYYY-MM-DD'),
      sort: 'kmasc',
      isDispatching: false,
      group: [],
      selectedGroup: null
    };
  },
  computed: {
    ...mapGetters(['directionByAirLines'])
  },
  watch: {
    date () {
      window.getApp.showLoading(true);
      this.removeNewAndRestCases();
      setTimeout(() => {
        this.findSupporters();
      }, 1000);
    },
    sort () {
      localStorage.setItem('dispatchSort', this.sort);
      this.sortSupporters(this.sort);
    },
    directionByAirLines () {
      if (this.directionByAirLines) {
        window.getApp.showMessage(
          'Hết lượt định tuyến Google, sử dụng định tuyến theo đường thẳng'
        );
        this.findSupporters();
      }
    }
  },
  async mounted () {
    await this.getGroup();
    let selected = localStorage.getItem('selectedGroup');
    this.selectedGroup = selected ? JSON.parse(selected) : null;

    let sort = localStorage.getItem('dispatchSort');
    this.sort = sort ? sort : 'kmasc';

    window.getApp.showLoading(true);
    if (this.selectedCase.Plan) {
      this.date = moment(this.selectedCase.Plan).format('YYYY-MM-DD');
    } else if (this.selectedCase.InstallationFrom) {
      this.date = moment(this.selectedCase.InstallationFrom).format(
        'YYYY-MM-DD'
      );
    } else {
      this.date = moment().format('YYYY-MM-DD');
    }
    // console.log('🚀 ~ file: overview.vue ~ line 65 ~ created ~ this.supporters', this.supporters);
  },
  methods: {
    ...mapActions([
      'GoogleMapGeoCodeding',
      'FastMapDirections',
      'TicketDispatchCrmBitrix',
      'GetUserGroup'
    ]),
    ...mapMutations(['UPDATE_REPAIR_PERSON', 'SET_DIRECTION_BY_AIR_LINES']),
    displayCurrentTime (index) {
      let now = moment().hour();
      return index === ++now ? 'marker' : '';
    },
    async getGroup () {
      let res = await this.GetUserGroup().catch(_ => {
        return [];
      });

      this.group = res || [];
      // console.log('🚀 ~ file: Tasks.vue ~ line 204 ~ getGroup ~ res', res);
      
    },
    getWorkingStatus (status) {
      switch (status) {
        case 'Ready':
          return ['Ready', 'success'];
        case 'Plan':
          return ['Plan', 'red'];
        default:
          return ['Offline', 'grey darken-2'];
      }
    },
    getTaskDuration (task) {
      if (task.Plan) {
        let start = moment(task.Plan);
        let end = moment(start).add(task.InstallationDuration, 'minutes');
        let startHour = start.hour();
        let endHour = end.hour();

        return `grid-column: ${startHour}/${endHour}`;
      }
    },
    // eslint-disable-next-line complexity
    getTaskColor (task) {
      if (task.Type === 'Rest') {
        return 'transparent';
      } else if (task.Type === 'New') {
        return 'error';
      } else if ((task.Status === 'RePlan' || task.Status === 'Re-Plan') && task.RePlanTime) {
        return 'deep-purple lighten-2';
      } else if (
        task.Started &&
        task.Finished &&
        task.Status !== 'PendingInput' &&
        task.Status !== 'Closed'
      ) {
        return 'success';
      } else if (task.Started && !task.Finished && task.Status === 'Assigned') {
        if (task.DelayFinish === 'True') return 'indigo darken-3';
        return 'orange';
      } else if (
        task.Started &&
        task.Finished &&
        task.Status === 'PendingInput'
      ) {
        return 'deep-purple lighten-2';
      } else if (task.Started && task.Finished && task.Status === 'Closed') {
        return 'grey';
      } else if (
        task.WaitingFrom && 
        task.WaitingLocation && 
        !task.Started && 
        !task.Finished
        && task.Status !== 'Closed'
      ) { 
        return 'pink darken-1';
      }
      return 'blue';
    },
    handleChangeGroup (data) {
      localStorage.setItem('selectedGroup', JSON.stringify(data));
      this.selectedGroup = data;
      this.search();
    },
    directionByAirLine (origin, destination) {
      let latlng1 = origin.split(',');
      let latlng2 = destination.split(',');

      let distance = MapUtil.calcDistance(
        latlng1[0],
        latlng1[1],
        latlng2[0],
        latlng2[1]
      );
      distance = distance * 1.5; // meter
      let avgSpeed = 0.277777778; // m/s ~ 30 Km/h
      // t = s / v
      let duration = distance / avgSpeed;

      if (latlng1.length !== 2 || latlng2.length !== 2) {
        window.getApp.showMessage('Location không đúng định dạng', 'error');
        duration = 0;
        distance = 0;
      }

      let result = {
        duration: {
          value: duration
        },
        distance: {
          value: distance
        }
      };

      return result;
    },
    getDateFromHour (hour) {
      // :08:00
      let h = hour.split(':')[0];
      let m = hour.split(':')[1];
      let d = moment(this.date);
      let date = new Date(d.year(), d.month(), d.date(), h, m, 0);
      return moment(date);
    },
    removeNewAndRestCases () {
      this.supporters.map(s => {
        s.Cases = s.Cases
          ? s.Cases.filter(f => f.Type !== 'New' && f.Type !== 'Rest')
          : [];
        s.Freetimes = [];
        return 0;
      });
    },
    sortCaseByTime (sup) {
      sup.Cases.sort((a, b) => {
        let timeA = moment(a.Plan);
        let timeB = moment(b.Plan);
        return timeA - timeB;
      });
    },
    sortSupporters (sort) {
      switch (sort) {
        case 'caseasc': {
          this.datasourceFiltered.sort((a, b) => {
            let casesA = this.countCaseBySupporter(a);
            let casesB = this.countCaseBySupporter(b);
            return casesA - casesB;
          });
          break;
        }
        case 'casedesc': {
          this.datasourceFiltered.sort((a, b) => {
            let casesA = this.countCaseBySupporter(a);
            let casesB = this.countCaseBySupporter(b);
            return casesB - casesA;
          });
          break;
        }
        case 'vehicleasc': {
          this.datasourceFiltered.sort((a, b) => {
            let casesA = this.countVehicleBySupporter(a)[0];
            let casesB = this.countVehicleBySupporter(b)[0];
            return casesA - casesB;
          });
          break;
        }
        case 'vehicledesc': {
          this.datasourceFiltered.sort((a, b) => {
            let casesA = this.countVehicleBySupporter(a)[0];
            let casesB = this.countVehicleBySupporter(b)[0];
            return casesB - casesA;
          });
          break;
        }
        case 'timeasc': {
          this.datasourceFiltered.sort((a, b) => {
            let timeA = 0;
            let timeB = 0;

            a.Cases.map(c => {
              if (c.Type === 'New') {
                timeA = c.Before.Time + c.After.Time;
              }
              return 0;
            });
            b.Cases.map(c => {
              if (c.Type === 'New') {
                timeB = c.Before.Time + c.After.Time;
              }
              return 0;
            });
            return timeA - timeB;
          });
          break;
        }
        case 'timedesc': {
          this.datasourceFiltered.sort((a, b) => {
            let timeA = 0;
            let timeB = 0;

            a.Cases.map(c => {
              if (c.Type === 'New') {
                timeA = c.Before.Time + c.After.Time;
              }
              return 0;
            });
            b.Cases.map(c => {
              if (c.Type === 'New') {
                timeB = c.Before.Time + c.After.Time;
              }
              return 0;
            });
            return timeB - timeA;
          });
          break;
        }
        case 'kmasc': {
          this.datasourceFiltered.sort((a, b) => {
            let distanceA = 0;
            let distanceB = 0;

            a.Cases.map(c => {
              if (c.Type === 'New') {
                distanceA = c.Before.Distance + c.After.Distance;
              }
              return 0;
            });
            b.Cases.map(c => {
              if (c.Type === 'New') {
                distanceB = c.Before.Distance + c.After.Distance;
              }
              return 0;
            });
            return distanceA - distanceB;
          });
          break;
        }
        case 'kmdesc': {
          this.datasourceFiltered.sort((a, b) => {
            let distanceA = 0;
            let distanceB = 0;

            a.Cases.map(c => {
              if (c.Type === 'New') {
                distanceA = c.Before.Distance + c.After.Distance;
              }
              return 0;
            });
            b.Cases.map(c => {
              if (c.Type === 'New') {
                distanceB = c.Before.Distance + c.After.Distance;
              }
              return 0;
            });
            return distanceB - distanceA;
          });
          break;
        }
        default:
          break;
      }
    },
    getPlanFromTime (time) {
      return time.add(-7, 'hours').format('YYYY-MM-DD HH:mm:ss');
    },
    getTimeFromPlan (plan) {
      return moment(plan).add(7, 'hours');
    },
    getDurationFromCase (c) {
      if (!c.Finished) {
        return this.getTimeFromPlan(c.Plan).add(
          c.InstallationDuration,
          'minutes'
        );
      }
      return this.getTimeFromPlan(c.Finished);
    },
    countCaseBySupporter (sup) {
      return sup.Cases.filter(
        a =>
          this.getTimeFromPlan(a.Plan).date() === moment(this.date).date() &&
          a.Type !== 'New' &&
          a.Type !== 'Rest'
      ).length;
    },
    countVehicleBySupporter (sup) {
      let newCount = 0;
      let repairCount = 0;

      sup.Cases.filter(
        a =>
          this.getTimeFromPlan(a.Plan).date() === moment(this.date).date() &&
          a.Type !== 'New' &&
          a.Type !== 'Rest'
      ).map(a => {
        if (a.InstallationQuantity) {
          if (a.ErrorType === 'New') {
            newCount += Number(a.InstallationQuantity);
          } else {
            repairCount += Number(a.InstallationQuantity);
          }
        }
        return 0;
      });
      return [newCount + repairCount, newCount, repairCount];
    },
    getCrmCaseUrl (task) {
      return `http://vmcrm.quanlyxe.vn/index.php?module=Cases&action=DetailView&record=${task.Id}`;
    },
    findSupporters () {
      this.removeNewAndRestCases();
      if (this.selectedCase.Plan) {
        this.findSupportersWithPlan();
      } else {
        this.findSupportersWithoutPlan();
      }
    },
    async findSupportersWithoutPlan () {
      console.log('Find supporter without plan');

      window.getApp.showLoading(true);

      // input case
      // giờ khách hàng cho phép  lắp đặt, ngày, fromTime, toTime => selected date = ngày khách cho phép
      // nếu không có ngày khách hẹn thì default là ngày được chọn, set fromTime toTime là giờ hành chính
      let installationFrom = this.selectedCase.InstallationFrom;
      let installationTo = this.selectedCase.InstallationTo;

      let workingHours = hour =>
        moment(
          new Date(
            moment(this.date).year(),
            moment(this.date).month(),
            moment(this.date).date(),
            hour,
            0,
            0
          )
        );
      if (!installationFrom) installationFrom = workingHours(8);
      if (!installationTo) installationTo = workingHours(17);

      // Clear data
      this.datasource = [];
      this.datasourceFiltered = [];

      let location = this.selectedCase.Location && this.selectedCase.Location.split(',');
      console.log('🚀 ~ file: overview.vue ~ line 630 ~ findSupportersWithoutPlan ~ location', location);

      // chỉ lọc ra những sup Ready để nhận thêm task
      // chỉ lọc ra những sup có waypoint
      // tính khoảng cách theo đường chim bay, loại bỏ những sup ở quá xa trên 50Km
      let data = [
        ...this.supporters
          .filter(sup => sup.WorkingStatus === 'Ready')
          .filter(sup => sup.Waypoint)
          .filter(sup => {
            let lat = sup.Waypoint.Last.Y * Math.pow(10, -6);
            let lng = sup.Waypoint.Last.X * Math.pow(10, -6);
            let distance = MapUtil.calcDistance(
              location[0],
              location[1],
              lat,
              lng,
              'K'
            );
            return distance < 40;
          })
      ];

      if (data.length === 0) {
        window.getApp.showMessage(
          'Không có kỹ thuật viên nào trong bán kính 40km',
          'error'
        );
      }

      // Tính khoảng thời gian rãnh của các sup
      // eslint-disable-next-line complexity
      data.map(sup => {
        // Ràng buộc về thời gian làm việc và nghỉ ngơi
        let startWorkingTime = '08:00';
        let startRestTime = '12:00';
        let endRestTime = '13:00';
        let endWorkingTime = '17:00';
        let allowOT = false;
        let allowOR = true;
        // TODO
        // gio lam viec, defaul 8 - 17
        // thoi gian nghi trưa, default 12-13
        // chap nhan OT, thong trua, default = false

        // Thêm một case là giờ nghỉ trưa của ngày được chọn
        if (!allowOR) {
          let fromTime = this.getDateFromHour(startRestTime);
          let toTime = this.getDateFromHour(endRestTime);
          let duration = moment.duration(toTime.diff(fromTime)).asMinutes();
          if (
            sup.Cases.filter(
              c =>
                c.Type === 'Rest' &&
                moment(c.Plan).date() === moment(this.date).date()
            ).length === 0
          ) {
            sup.Cases.push({
              Plan: this.getPlanFromTime(fromTime),
              InstallationDuration: duration,
              Type: 'Rest',
              CaseNumber: 'Rest'
            });
            this.sortCaseByTime(sup);
          }
        }

        // Lọc ra các freetime của sup dựa trên các case và thời gian nghỉ trưa của ngày được chọn, chỉ chọn các case phù hợp thời gian lắp đặt
        let freetimes = [];
        let cases = sup.Cases.filter(
          a => moment(a.Plan).date() === moment(this.date).date()
        );
        for (let index = 0; index < cases.length; index++) {
          const caseBefore = cases[index - 1];
          const caseAfter = cases[index];
          let freeTimeFrom =
            index === 0
              ? this.getDateFromHour(startWorkingTime)
              : this.getDurationFromCase(caseBefore);
          let freeTimeTo = this.getTimeFromPlan(caseAfter.Plan);
          let duration = moment
            .duration(freeTimeTo.diff(freeTimeFrom))
            .asMinutes();
          freetimes.push({
            duration,
            caseBefore: caseBefore,
            caseAfter: caseAfter
          });
          if (index === cases.length - 1) {
            freeTimeFrom = this.getTimeFromPlan(caseAfter.Plan);
            freeTimeTo = this.getDateFromHour(endWorkingTime);
            duration = moment
              .duration(freeTimeTo.diff(freeTimeFrom))
              .asMinutes();
            freetimes.push({
              duration,
              caseBefore: caseAfter,
              caseAfter: undefined
            });
          }
        }
        if (cases.length === 0) {
          let freeTimeFrom = this.getDateFromHour(startWorkingTime);
          let freeTimeTo = this.getDateFromHour(endWorkingTime);
          freetimes.push({
            duration: moment
              .duration(freeTimeTo.diff(freeTimeFrom))
              .asMinutes(),
            caseBefore: undefined,
            caseAfter: undefined
          });
        }
        sup['Freetimes'] = freetimes;
        return 0;
      });

      // Dựa theo khoảng thời gian rãnh, loại bỏ tg không phù hợp, tính thời gian di chuyển giữa các case và case mới phát sinh
      data.map(sup => {
        sup.Freetimes.map(f => {
          let doCaseFrom = f.caseBefore
            ? this.getDurationFromCase(f.caseBefore)
            : moment(installationFrom);

          let newCase = {
            Id: this.selectedCase.Id,
            CaseNumber: this.selectedCase.CaseNumber,
            Type: 'New',
            InstallationDuration: this.selectedCase.InstallationDuration,
            RepairLocation: this.selectedCase.RepairLocation,
            Location: this.selectedCase.Location,
            RepairPersonId: sup.Id,
            RepairPerson: sup.Name,
            Plan: this.getPlanFromTime(doCaseFrom),
            Before: {
              Time: 0,
              Distance: 0,
              Case: f.caseBefore
            },
            After: {
              Time: 0,
              Distance: 0,
              Case: f.caseAfter
            }
          };

          sup.Cases.push(newCase);
          this.sortCaseByTime(sup);
          return 0;
        });

        // eslint-disable-next-line complexity
        sup.Cases.map(async item => {
          if (item.Type === 'New') {
            const startTime = moment(item.Plan);
            const endTime = startTime.add(item.InstallationDuration, 'minutes');
            const selectedDate = moment(this.date);

            // Xóa những case có ngày bắt đầu nhỏ hơn ngày hiện tại
            if (endTime.date() < moment().date()) {
              item['Hide'] = true;
            }

            if (
              item.After.Case !== undefined &&
              endTime > this.getTimeFromPlan(item.After.Case.Plan)
            ) {
              item['Hide'] = true;
            }

            // today
            // neu start time cua case nho hon qua khu nhung van con thoi gian de thuc hien case thi set start time = hien tai
            if (
              selectedDate.date() === moment().date() &&
              moment().hour() >= startTime.add(6, 'hours').hour()
            ) {
              item.Plan = this.getPlanFromTime(moment());
            }

            // tinh khoang cach tren cac case con lai
            // BEFORE
            let locationBefore = `${sup.Waypoint.Last.Y *
              Math.pow(10, -6)},${sup.Waypoint.Last.X * Math.pow(10, -6)}`;
            if (item.Before.Case && item.Before.Case.Location) {
              locationBefore = item.Before.Case.Location.replace(/\s/g, '');
            }

            // NEW CASE
            let newCaseLocation = item.Location.replace(/\s/g, '');

            // AFTER
            let locationAfter = '0,0';
            if (item.After.Case && item.After.Case.Location) {
              locationAfter = item.After.Case.Location.replace(/\s/g, '');
            }

            if (!this.directionByAirLines) {
              this.FastMapDirections({
                origin: locationBefore,
                destination: newCaseLocation
              })
                .then(res => {
                  console.log('before', res);

                  item.Before.Time = res.duration ? res.duration.value : 0;
                  item.Before.Distance = res.distance ? res.distance.value : 0;
                })
                .catch(_ => {
                  item.Before.Time = 0;
                  item.Before.Distance = 0;
                });

              if (locationAfter !== '0,0') {
                this.FastMapDirections({
                  origin: newCaseLocation,
                  destination: locationAfter
                })
                  .then(res => {
                    console.log('after', res);

                    item.After.Time =
                      res.duration < 60 ? res.duration.value : 0;
                    item.After.Distance =
                      res.distance < 60 ? res.distance.value : 0;
                  })
                  .catch(_ => {
                    item.After.Time = 0;
                    item.After.Distance = 0;
                  });
              } else {
                item.After.Time = 0;
                item.After.Distance = 0;
              }
            } else {
              let res = this.directionByAirLine(
                locationBefore,
                newCaseLocation
              );
              item.Before.Time = res.duration ? res.duration.value : 0;
              item.Before.Distance = res.distance ? res.distance.value : 0;

              res = this.directionByAirLine(newCaseLocation, locationAfter);
              item.After.Time = res.duration < 60 ? res.duration.value : 0;
              item.After.Distance = res.distance < 60 ? res.distance.value : 0;
            }

            const newEndTime = this.getTimeFromPlan(item.Plan)
              .add(this.selectedCase.InstallationDuration, 'minutes')
              .add(item.Before.Time, 'minutes')
              .add(item.After.Time, 'minutes');

            item.Plan = this.getPlanFromTime(
              this.getTimeFromPlan(item.Plan).add(item.Before.Time, 'minutes')
            );

            if (
              item.After.Case !== undefined &&
              newEndTime > this.getTimeFromPlan(item.After.Case.Plan)
            ) {
              item['Hide'] = true;
            }

            this.$forceUpdate();
          }
          return 0;
        });
        return 0;
      });

      window.getApp.showLoading(false);

      this.datasource = data;
      this.datasourceFiltered = data;
      this.search();
      this.sort = 'kmasc';
      this.sortSupporters('kmasc');
    },
    async findSupportersWithPlan () {
      console.log('Find supporter with Plan');
      console.log('TCL: findSupportersWithPlan ->  this.selectedCase', this.selectedCase);
      console.log('TCL: findSupportersWithPlan ->  this.supporters', this.supporters);

      window.getApp.showLoading(true);

      let installationFrom = this.selectedCase.InstallationFrom;
      let installationTo = this.selectedCase.InstallationTo;
      let workingHours = hour =>
        moment(
          new Date(
            moment(this.date).year(),
            moment(this.date).month(),
            moment(this.date).date(),
            hour,
            0,
            0
          )
        );
      if (!installationFrom) installationFrom = workingHours(8);
      if (!installationTo) installationTo = workingHours(17);

      console.log('installationFrom', installationFrom);
      console.log('installationTo', installationTo);

      this.datasource = [];
      this.datasourceFiltered = [];
      let location = this.selectedCase.Location.split(',');

      console.log('location', location);

      let data = [
        ...this.supporters
          .filter(sup => sup.WorkingStatus === 'Ready')
          .filter(sup => sup.Waypoint)
          .filter(sup => {
            let lat = sup.Waypoint.Last.Y * Math.pow(10, -6);
            let lng = sup.Waypoint.Last.X * Math.pow(10, -6);
            let distance = MapUtil.calcDistance(
              location[0],
              location[1],
              lat,
              lng,
              'K'
            );
            return distance < 40;
          })
      ];

      let selectedPlanHours = new Date(convertGMTToLocalTime(this.selectedCase.Plan)).getHours();
      if (selectedPlanHours <= 12) data = data.filter(s => s.MorningOffline !== 'True'); // selected case plan <= 12h => check nghỉ sáng
      else if (selectedPlanHours > 13) data = data.filter(s => s.AfternoonOffline !== 'True'); // selected case plan > 13h => check nghỉ chiều 

      if (data.length === 0) {
        window.getApp.showMessage(
          'Không có kỹ thuật viên nào trong bán kính 40km',
          'error'
        );
      }
      console.log('data (ready, have waypoints, distance < 20 km)', data);

      // Tính khoảng thời gian rảnh của các sup
      // eslint-disable-next-line complexity 
      data.map(sup => {
        // Ràng buộc về thời gian làm việc và nghỉ ngơi
        let startWorkingTime = '08:00';
        let startRestTime = '12:00';
        let endRestTime = '13:00';
        let endWorkingTime = '17:00';
        let allowOT = true;
        let allowOR = true;

        // Thêm một case là giờ nghỉ trưa của ngày được chọn
        if (!allowOR) {
          let fromTime = this.getDateFromHour(startRestTime);
          let toTime = this.getDateFromHour(endRestTime);
          let duration = moment.duration(toTime.diff(fromTime)).asMinutes();
          if (
            sup.Cases.filter(
              c =>
                c.Type === 'Rest' &&
                moment(c.Plan).date() === moment(this.date).date()
            ).length === 0
          ) {
            sup.Cases.push({
              Plan: this.getPlanFromTime(fromTime),
              InstallationDuration: duration,
              Type: 'Rest',
              CaseNumber: 'Rest'
            });
            this.sortCaseByTime(sup);
          }
        }

        // Lọc ra các freetime của sup dựa trên các case và thời gian nghỉ trưa của ngày được chọn, chỉ chọn các case phù hợp thời gian lắp đặt
        let freetimes = [];
        let cases = sup.Cases.filter(
          a => this.getTimeFromPlan(a.Plan).date() === moment(this.date).date()
        );
        for (let index = 0; index < cases.length; index++) {
          const caseBefore = cases[index - 1];
          const caseAfter = cases[index];
          let freeTimeFrom =
            index === 0
              ? this.getDateFromHour(startWorkingTime)
              : this.getDurationFromCase(caseBefore);
          let freeTimeTo = this.getTimeFromPlan(caseAfter.Plan);
          let duration = moment
            .duration(freeTimeTo.diff(freeTimeFrom))
            .asMinutes();
          freetimes.push({
            duration,
            caseBefore: caseBefore,
            caseAfter: caseAfter
          });
          if (index === cases.length - 1) {
            freeTimeFrom = this.getTimeFromPlan(caseAfter.Plan);
            freeTimeTo = this.getDateFromHour(endWorkingTime);
            duration = moment
              .duration(freeTimeTo.diff(freeTimeFrom))
              .asMinutes();
            freetimes.push({
              duration,
              caseBefore: caseAfter,
              caseAfter: undefined
            });
          }
        }
        if (cases.length === 0) {
          let freeTimeFrom = this.getDateFromHour(startWorkingTime);
          let freeTimeTo = this.getDateFromHour(endWorkingTime);
          freetimes.push({
            duration: moment
              .duration(freeTimeTo.diff(freeTimeFrom))
              .asMinutes(),
            caseBefore: undefined,
            caseAfter: undefined
          });
        }

        sup['Freetimes'] = freetimes;

        console.log('sup', sup.Name);
        console.log('freetimes', freetimes);

        return 0;
      });

      // Dựa theo khoảng thời gian rảnh, loại bỏ tg không phù hợp, tính thời gian di chuyển giữa các case và case mới phát sinh
      data.map(sup => {
        sup.Freetimes.map(f => {
          let doCaseFrom = f.caseBefore
            ? this.getDurationFromCase(f.caseBefore)
            : moment(installationFrom);

          let newCase = {
            Id: this.selectedCase.Id,
            CaseNumber: this.selectedCase.CaseNumber,
            Type: 'New',
            InstallationDuration: this.selectedCase.InstallationDuration,
            RepairLocation: this.selectedCase.RepairLocation,
            Location: this.selectedCase.Location,
            RepairPersonId: sup.Id,
            RepairPerson: sup.Name,
            Plan: this.getPlanFromTime(doCaseFrom),
            Before: {
              Time: 0,
              Distance: 0,
              Case: f.caseBefore
            },
            After: {
              Time: 0,
              Distance: 0,
              Case: f.caseAfter
            }
          };

          sup.Cases.push(newCase);
          this.sortCaseByTime(sup);
          return 0;
        });

        // eslint-disable-next-line complexity
        sup.Cases.map(async item => {
          if (item.Type === 'New') {
            const startTime = this.getTimeFromPlan(item.Plan);
            const endTime = startTime.add(item.InstallationDuration, 'minutes');
            const selectedDate = moment(this.date);

            // Xóa những case có ngày bắt đầu nhỏ hơn ngày hiện tại
            if (endTime.date() < moment().date()) {
              // item['Hide'] = true;
            }

            item.Plan = this.selectedCase.Plan;
            // tinh khoang cach tren cac case con lai
            // BEFORE
            let locationBefore = `${sup.Waypoint.Last.Y *
              Math.pow(10, -6)},${sup.Waypoint.Last.X * Math.pow(10, -6)}`;
            if (item.Before.Case && item.Before.Case.Location) {
              locationBefore = item.Before.Case.Location.replace(/\s/g, '');
            }

            // NEW CASE
            let newCaseLocation = item.Location.replace(/\s/g, '');
            // AFTER
            let locationAfter = '0,0';
            if (item.After.Case && item.After.Case.Location) {
              locationAfter = item.After.Case.Location.replace(/\s/g, '');
            }
            if (!this.directionByAirLines) {
              this.FastMapDirections({
                origin: locationBefore,
                destination: newCaseLocation
              }).then(res => {
                if (!res.error_message) {
                  item.Before.Time = res.duration ? res.duration.value : 0; // seconds
                  item.Before.Distance = res.distance ? res.distance.value : 0; // meter
                } else {
                  this.SET_DIRECTION_BY_AIR_LINES(true);
                }
              });
              this.FastMapDirections({
                origin: newCaseLocation,
                destination: locationAfter
              }).then(res => {
                if (!res.error_message) {
                  item.After.Time = res.duration < 60 ? res.duration.value : 0; // seconds
                  item.After.Distance =
                    res.distance < 60 ? res.distance.value : 0; // meter
                } else {
                  this.SET_DIRECTION_BY_AIR_LINES(true);
                }
              });
            } else {
              let res = this.directionByAirLine(
                locationBefore,
                newCaseLocation
              );
              item.Before.Time = res.duration ? res.duration.value : 0; // seconds
              item.Before.Distance = res.distance ? res.distance.value : 0; // meter

              res = this.directionByAirLine(newCaseLocation, locationAfter);
              item.After.Time = res.duration < 60 ? res.duration.value : 0; // seconds
              item.After.Distance = res.distance < 60 ? res.distance.value : 0; // meter
            }

            if (item.Before.Case) {
              const startTime = this.getDurationFromCase(item.Before.Case).add(
                item.Before.Time
              );
              if (startTime >= this.getTimeFromPlan(item.Plan)) {
                item['Hide'] = true;
              }
            }
            if (item.After.Case) {
              const endTime = this.getDurationFromCase(item).add(
                item.After.Time
              );
              if (endTime >= this.getTimeFromPlan(item.After.Case.Plan)) {
                item['Hide'] = true;
              }
            }

            this.$forceUpdate();
          }
          return 0;
        });
        return 0;
      });

      window.getApp.showLoading(false);

      this.datasource = data;
      this.datasourceFiltered = data;
      this.search();
      this.sort = 'kmasc';
      this.sortSupporters('kmasc');
    },
    async dispatch (task, wehbook) {
      this.isDispatching = true;
      if (task.CaseNumber !== 'Quick Dispatch') {
        let res = await this.TicketDispatchCrmBitrix({
          id: task.Id,
          repairPersonId: task.RepairPersonId,
          plan: task.Plan,
          updatePlan: this.selectedCase.Plan ? false : true,
          // Webhook: wehbook,
          // CaseNumber: task.CaseNumber
        });
        if (res) {
          this.$emit('display', false);
          this.UPDATE_REPAIR_PERSON(task);
          window.open(this.getCrmCaseUrl(task), '_blank');
        }
      } else {
        let date = moment(task.Plan).add(7, 'hours');
        let dStr = date.format('YYYY-MM-DD HH:mm');
        window.open(`http://vmcrm.quanlyxe.vn/index.php?module=Cases&action=EditView&return_module=Cases&return_action=DetailView&location_c=${task.Location}&plan_repair_time_c=${dStr}`, '_blank');
      }
      this.isDispatching = false;
    },
    search () {
      if (this.selectedGroup && this.selectedGroup.Id) {
        this.datasourceFiltered = this.datasource.filter(
          a => a.GroupId === this.selectedGroup.Id
        );
      } else {
        this.datasourceFiltered = this.datasource;
      }
    },
    updateCasePlan (task) {
      console.log(this.$refs[`Case-${task.CaseNumber}`].value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto:100,400,700");
body,
html {
  font-family: "Roboto", sans-serif;
  background-color: #cddade;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.header {
  color: #202125;
  margin-bottom: 40px;
  h2 {
    font-weight: 600;
  }
  p {
    font-weight: 300;
  }
}
$red: #ff6252;
.wrapper {
  max-width: 1200px;
  min-width: 700px;
  margin: 0 auto;
  padding: 40px;
}
.gantt {
  display: grid;
  border: 0;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  //border-radius: 12px;
  // box-shadow: 0 75px 125px -57px #7e8f94;

  &__row {
    display: grid;
    grid-template-columns: 170px 1fr;
    background-color: #fff;
    &:nth-child(odd) {
      background-color: #f5f5f5;
      .gantt__row-first {
        background-color: #f5f5f5;
      }
    }
    &:nth-child(3) {
      .gantt__row-bars {
        border-top: 0;
      }
      .gantt__row-first {
        border-top: 0;
      }
    }
    &--empty {
      background-color: lighten($red, 25%) !important;
      z-index: 1;
      .gantt__row-first {
        border-width: 1px 1px 0 0;
      }
    }
    &--lines {
      position: absolute;
      height: 100%;
      width: 100%;
      background-color: transparent;
      grid-template-columns: 170px repeat(13, 1fr);
      span {
        display: block;
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        &.marker {
          background-color: rgba(10, 52, 68, 0.2);
        }
      }
      &:after {
        grid-row: 1;
        grid-column: 0;
        background-color: #1688b345;
        z-index: 2;
        height: 100%;
      }
    }
    &--months {
      color: #0a3444;
      background-color: #ffffff !important;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      grid-template-columns: 170px repeat(13, 1fr);
      .gantt__row-first {
        border-top: 0 !important;
        background-color: #ffffff !important;
      }
      span {
        text-align: center;
        font-size: 13px;
        align-self: center;
        font-weight: bold;
        padding: 20px 0;
      }
    }
    &-first {
      background-color: #fff;
      border-width: 1px 0 0 0;
      border-color: rgba(0, 0, 0, 0.1);
      border-style: solid;
      padding: 15px 0;
      font-size: 13px;
      font-weight: bold;
      text-align: center;
    }
    &-bars {
      list-style: none;
      display: grid;
      padding: 9px 0;
      margin: 0;
      grid-template-columns: repeat(13, 1fr);
      grid-gap: 8px 0;
      border-top: 1px solid rgba(221, 221, 221, 0.8);
      li {
        font-weight: 500;
        text-align: center;
        font-size: 14px;
        min-height: 15px;
        background-color: #55de84;
        padding: 5px 12px;
        color: #fff;
        overflow: hidden;
        position: relative;
        //cursor: pointer;
        //border-radius: 20px;
        //height: 30px;

        &.stripes {
          background-image: repeating-linear-gradient(
            45deg,
            transparent,
            transparent 5px,
            rgba(255, 255, 255, 0.1) 5px,
            rgba(255, 255, 255, 0.1) 12px
          );
        }

        &:before,
        &:after {
          content: "";
          height: 100%;
          top: 0;
          z-index: 4;
          position: absolute;
          background-color: rgba(0, 0, 0, 0.3);
        }
        &:before {
          left: 0;
        }
        &:after {
          right: 0;
        }
      }
    }
  }

  &__head {
    &--left {
      float: left;
      padding: 4px 0px 0px 8px;
    }
    &--right {
      float: right;
      padding: 4px 12px 0px 0px;
    }
  }
}
.chip {
  margin-top: -1px;
}
.clear {
  clear: both;
}
.small-icon {
  font-size: 13pt;
  margin-right: 4px;
}
.select-button {
  width: 90%;
  margin-left: 5%;
}
.name {
  font-size: 12pt;
}
.case-number-label {
  cursor: pointer;
}
.case-driving {
  cursor: pointer;
  font-size: 8pt !important;
  text-align: left !important;
}
.task-detail {
  margin-bottom: 0px !important;
  margin-top: 8px !important;
}
.blank {
  height: 64px;
  background-color: #0a3444;
}
.top-toolbar {
  height: 56px;

  &-button {
    margin-top: -2px;
  }
  &-textfield {
    margin-top: 4px;
  }
}
.task-rest {
  font-size: 16pt !important;
  color: rgb(223, 223, 223) !important;
}
.sup-name {
  text-align: left !important;
  padding-left: 8px;
  color: #1976d2 !important;
}
.para {
  margin-bottom: 4px !important;
  font-weight: normal !important;
  text-align: left !important;
  padding-left: 8px;
}
.date-picker {
  margin-right: 12px !important;
}
.v-btn--active {
  opacity: 1;
  background: #c7c7c7;
}
.dispatch-dialog {
  z-index: 300 !important;
}
.vehicle-icon {
  font-size: 11pt;
}
.btn-group {
  margin-top: -8px;
  margin-right: 4px;
}
.toolbar-item {
  width: 200px !important;
  margin-left: 8px !important;
  margin-top: 4px !important;
}
.help-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dispatch/Overview.vue